import React, { useEffect, useState } from 'react';
import { ColumnTitle } from 'antd/lib/table/interface';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';
import { List, Switch } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import arrayMove from 'array-move';

interface IOrderedListProps {
  items?: {
    title?: ColumnTitle<any>;
    visible?: boolean;
  }[];
  onChange: (array: any) => void;
  switchItemChange?: (indexItem: number) => void;
  disabled?: boolean;
}

const SortableList: React.FC<IOrderedListProps> = ({
  items,
  onChange,
  switchItemChange,
  disabled = false,
}) => {
  const [listItems, setListItems] = useState(items);

  useEffect(() => {
    setListItems(items);
  }, [items]);

  useEffect(() => {
    onChange(listItems);
  }, [listItems, onChange]);

  const DragHandle = SortableHandle(() => (
    <MenuOutlined style={{ cursor: 'pointer' }} />
  ));

  const SortableItem = SortableElement(({ item, sortIndex }: any) => (
    <List.Item
      actions={[
        switchItemChange && (
          <Switch
            size="small"
            checked={item.visible}
            onChange={() => switchItemChange(sortIndex)}
          />
        ),
      ]}
    >
      <List.Item.Meta avatar={<DragHandle />} title={item.title} />
    </List.Item>
  ));

  const Sortable = SortableContainer(() => (
    <List
      size="small"
      itemLayout="horizontal"
      dataSource={listItems}
      style={{ width: '100%' }}
      className={`disabled-selection ${
        disabled ? 'sortable-list-disabled' : ''
      }`}
      renderItem={(item, index) => (
        <SortableItem
          disabled={disabled}
          index={index}
          // @ts-ignore
          item={item}
          sortIndex={index}
        />
      )}
    />
  ));

  const onSortEnd = ({
    oldIndex,
    newIndex,
  }: {
    oldIndex: number;
    newIndex: number;
  }) => {
    setListItems((itemsToMove: any) =>
      arrayMove(itemsToMove, oldIndex, newIndex),
    );
  };

  return (
    <Sortable
      useDragHandle
      helperClass="sortableHelper"
      onSortEnd={onSortEnd}
    />
  );
};

export default SortableList;
